import React, { useCallback } from 'react';
import { HashRouter as Router } from 'react-router-dom';

import { isAppInsightsEnabled } from './services/analytics/appInsights';

import { AppProvider, useAppData } from './context';
import configData from './config.json';

import { isRightToLeft } from './utils/helpers/locale.helper';
import Helmet from './components/Helmet/Helmet';
import AppRoutes from './routes/AppRoutes';
import Loading from './pages/Loading/Loading';
import DemoLabel from './components/DemoLabel/DemoLabel';
import { useAnalyticsScript } from './services/analytics/useAnalyticsScript';
import logger from './utils/helpers/logger.helper';
import TrackPageViews from './services/analytics/TrackPageViews';
import 'virtual:svg-icons-register';

function AppContent() {
  const { loading } = useAppData();

  if (loading) return <Loading />;

  return (
    <div className={isRightToLeft() ? 'rtl' : ''}>
      <Router>
        {isAppInsightsEnabled && <TrackPageViews />}

        <main>
          <DemoLabel />
          <AppRoutes />
        </main>
      </Router>
    </div>
  );
}

function App() {
  const handleAnalyticsScriptLoad = useCallback(async () => {
    if (!isAppInsightsEnabled) return;

    try {
      const { default: initConsentAnalyticsFlow } =
        await import('./services/analytics/initConsentAnalyticsFlow');

      initConsentAnalyticsFlow();
    } catch (error) {
      logger.error(error);
    }
  }, []);

  const handleAnalyticsScriptError = useCallback((error) => {
    logger.error(error);
  }, []);

  useAnalyticsScript(isAppInsightsEnabled ? configData.analyticsUrl : null, {
    onLoad: handleAnalyticsScriptLoad,
    onError: handleAnalyticsScriptError,
  });

  return (
    <>
      <Helmet />
      <AppProvider>
        <AppContent />
      </AppProvider>
    </>
  );
}

export default App;
